module.exports = __webpack_public_path__ + "static/womanandchildmobile-52caea59660be60109dec19d079be437.jpg";